import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { noop } from 'lodash';
import { PopOver } from 'Components/frameworks/pop-over/PopOver';
import { useResponsive } from 'Components/utils/responsive/ResponsiveContext';
import { ICONS } from 'Components/utils/icon/icons';
import { ProductFavorite } from 'Components/widgets/product/product-favorite/ProductFavorite';
export type ProductFavoriteContainerProps = {
  displayTooltipTimeoutInMs: number;
  iconName?: string;
  iconColor?: Colors;
  onClick?: () => void;
  isFilled?: boolean;
  isNextStep?: boolean;
  isReadyForBookingEngine?: boolean;
  isSticky: boolean;
  hasPrice?: boolean;
  priceOfStayIsLoading?: boolean;
  shouldAnimateEntry?: boolean;
  showFavoriteTooltip?: boolean;
  tooltipContent: string;
  triggerOnHover?: boolean;
};
export const ProductFavoriteContainer = ({
  displayTooltipTimeoutInMs,
  iconColor = '',
  shouldAnimateEntry = false,
  isFilled = false,
  isNextStep = false,
  isReadyForBookingEngine = true,
  isSticky,
  iconName = ICONS.STAR_HOLLOW,
  onClick = noop,
  hasPrice = true,
  priceOfStayIsLoading = false,
  showFavoriteTooltip = true,
  tooltipContent,
  triggerOnHover = false,
}: ProductFavoriteContainerProps) => {
  const { isDesktop } = useResponsive();
  const productFavorite = (
    <span
      className={classnames(
        `pointer-events-auto flex size-40 justify-center rounded-full border-1 border-lightGrey border-b-transparent border-l-transparent bg-white ${isSticky ? 'mx-auto border-lightGrey' : 'mx-10'} translate-y-1/2 -rotate-45 transform duration-250 ease-in`,
        {
          [`text-${iconColor}`]: (!shouldAnimateEntry || isFilled) && isReadyForBookingEngine,
        },
        {
          'translate-y-full !border-white text-white':
            (!isReadyForBookingEngine && !isFilled) || !hasPrice,
        },
        {
          'transition-all': isReadyForBookingEngine,
        },
      )}
    >
      <ProductFavorite
        className="rotate-45"
        data-testid="CTA-add-remove-favorite"
        iconName={iconName}
        isDisabled={priceOfStayIsLoading}
        onClick={onClick}
      />
    </span>
  );

  if (!hasPrice) {
    return null;
  }

  return isDesktop ? (
    <div
      className={`pointer-events-none absolute bottom-full duration-250 ease-in ${isSticky ? 'left-1/2 -translate-x-1/2 transform' : 'end-0'}`}
    >
      {isReadyForBookingEngine && hasPrice && !isFilled ? (
        <PopOver
          ariaLabel="favorite"
          content={<div className="w-180 p-10">{tooltipContent}</div>}
          isInitiallyVisible={
            isReadyForBookingEngine && !isFilled && !isNextStep && showFavoriteTooltip
          }
          theme={isSticky ? 'favorite-centered' : 'favorite'}
          timeoutInMs={displayTooltipTimeoutInMs}
          triggerOnHover={triggerOnHover}
        >
          {productFavorite}
        </PopOver>
      ) : (
        productFavorite
      )}
    </div>
  ) : (
    <div className={`pointer-events-none absolute bottom-full ${isSticky ? 'inset-x-0' : 'end-0'}`}>
      {productFavorite}
    </div>
  );
};
